/**
 * Number of posts per post index page.
 */
export const postsPerPage = 10;

export const indexPageTag = 'tech';

// used by Playwright
export const STATE_CHANGE_EVENT = 'REACT_ROUTER_PAGE_CHANGE_EVENT';

export const alertNotificationDuration = 1750; // ms

export const netlifyFunctionsApiPrefix = '/.netlify/functions';

/**
 * Content-column layout numbers shared by the responsive `sizes` math in
 * PostPreviewCover and ImageGridImage. Kept in one place so the JS `sizes`
 * strings can't silently drift from each other or the SCSS they mirror.
 *
 * These only shape the emitted `sizes` attribute — they never reach the image
 * pipeline, so changing them does not invalidate any scaled-variant cache.
 *
 * Mirrors SCSS:
 *   CONTENT_PADDING_PX    — 2 × --aml-global-layout-padding-sm (16px per side)
 *   CONTENT_MAX_WIDTH_PX  — max content-column width
 *   CONTENT_BREAKPOINT_PX — viewport above which the column stops scaling
 *   GRID_GAP_PX           — --aml-size-4 (ImageGrid / ImageGridRow `gap`)
 */
export const CONTENT_PADDING_PX = 32;
export const CONTENT_MAX_WIDTH_PX = 920;
export const CONTENT_BREAKPOINT_PX = 960;
export const GRID_GAP_PX = 8;

/** Full-content-width cover: featured card, and a single-image grid row. */
export const FULL_WIDTH_IMAGE_SIZES = `(width < ${CONTENT_BREAKPOINT_PX}px) calc(100vw - ${CONTENT_PADDING_PX}px), ${CONTENT_MAX_WIDTH_PX}px`;
